/* NEW-pre-glued-full-pdp.js
   Vanilla JS for the NEW PDP — gallery, tabs, variant pills, options, price/variant sync.
   Scoped to .new-pre-glued-full-pdp; runs once on DOMContentLoaded.
   Prices on this PDP are MONEY STRINGS (e.g. "£20"), not cents — parse/format accordingly. */
(function () {
  'use strict';

  /* Parse a money string ("£20", "£19.50") to a Number. */
  function parseMoney(str) {
    var n = parseFloat(String(str || '').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }
  /* Format a Number to a money string using the symbol from a sample string,
     mirroring Liquid's money_without_trailing_zeros (drops a whole ".00"). */
  function formatMoney(num, sample) {
    var m = String(sample || '£').match(/^[^\d.-]*/);
    var symbol = (m && m[0]) || '£';
    var fixed = num.toFixed(2).replace(/\.00$/, '');
    return symbol + fixed;
  }

  function init(root) {
    /* ── Gallery ─────────────────────────────────────── */
    var gallery = root.querySelector('[data-gallery]');
    if (gallery) {
      var thumbs = gallery.querySelectorAll('[data-thumb-index]');
      var slides = gallery.querySelectorAll('[data-slide-index]');
      var progress = gallery.querySelector('[data-progress]');
      var prev = gallery.querySelector('[data-prev]');
      var next = gallery.querySelector('[data-next]');
      var idx = 0;
      var total = slides.length;

      function show(i) {
        if (total === 0) return;
        idx = ((i % total) + total) % total;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
        if (progress) progress.style.width = ((idx + 1) / total * 100) + '%';
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.dataset.thumbIndex, 10)); }); });
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });

        // Swipe / drag the main image to change slides (mobile touch + desktop mouse drag)
        var stage = gallery.querySelector('[data-stage]');
        if (stage && total > 1) {
          var swX = 0, swY = 0, swActive = false, swDone = false, SW_THRESH = 40;
          function swStart(x, y) { swX = x; swY = y; swActive = true; swDone = false; }
          function swMove(x, y) {
            if (!swActive || swDone) return;
            var dx = x - swX, dy = y - swY;
            if (Math.abs(dx) > SW_THRESH && Math.abs(dx) > Math.abs(dy)) {
              swDone = true; swActive = false;
              show(idx + (dx < 0 ? 1 : -1));
            }
          }
          function swEnd() { swActive = false; }
          stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; swStart(t.clientX, t.clientY); }, { passive: true });
          stage.addEventListener('touchmove', function (e) { var t = e.touches[0]; swMove(t.clientX, t.clientY); }, { passive: true });
          stage.addEventListener('touchend', swEnd, { passive: true });
          stage.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; swStart(e.clientX, e.clientY); });
          stage.addEventListener('pointermove', function (e) { if (e.pointerType === 'touch') return; swMove(e.clientX, e.clientY); });
          window.addEventListener('pointerup', swEnd);
          stage.querySelectorAll('img').forEach(function (im) { im.addEventListener('dragstart', function (e) { e.preventDefault(); }); });
          stage.style.touchAction = 'pan-y';
        }
    }

    /* ── Element refs ────────────────────────────────── */
    var optionInputs = root.querySelectorAll('input[name="new-pre-glued-full-pdp-pack"]');
    var variantInput = root.querySelector('[data-variant-input]');
    var quantityInput = root.querySelector('[data-quantity-input]');
    var priceCurrent = root.querySelector('[data-price-current]');
    var priceCompare = root.querySelector('[data-price-compare]');
    var atcPrice = root.querySelector('[data-atc-price]');
    var atcCompare = root.querySelector('[data-atc-compare]');
    var klarnaAmount = root.querySelector('[data-klarna-amount]');
    var klarnaInstallments = parseInt((root.querySelector('[data-section-id]') || root).dataset.klarnaInstallments || '3', 10);

    function parsePrices(str) {
      if (!str) return null;
      try { var o = JSON.parse(str); return (o && typeof o === 'object') ? o : null; } catch (e) { return null; }
    }

    var subPanel = root.querySelector('[data-panel="subscribe"]');
    var sellingPlanInput = root.querySelector('[data-selling-plan-input]');
    var sellingPlanSelect = root.querySelector('[data-selling-plan-select]');
    var subPct = subPanel ? parseFloat(subPanel.dataset.subPct || '0') : 0;
    var subDesc = root.querySelector('[data-sub-desc]');
    var defaultPlanId = subPanel ? subPanel.dataset.defaultPlanId : null;
    // Per-variant Subscribe & Save target. In the native model this is the lash variant
    // itself (Appstle plan applied directly); in the fallback model it is a dedicated
    // subscription product variant. currentSubPrices maps plan id -> price (money string)
    // for the current length, so switching frequency reprices.
    var currentSubVariantId = subPanel ? (subPanel.dataset.subVariantId || null) : null;
    var currentSubPrice = subPanel ? (subPanel.dataset.subPrice || null) : null;
    var currentSubPrices = subPanel ? parsePrices(subPanel.dataset.subPrices) : null;
    var currentSubPlanId = defaultPlanId;
    var subscribeTab = root.querySelector('[data-tab="subscribe"]');

    /* Recurring price for a given plan id at the current length (falls back to default). */
    function subPriceForPlan(planId) {
      if (currentSubPrices && planId && currentSubPrices[planId]) return currentSubPrices[planId];
      return currentSubPrice;
    }

    var starterPanel = root.querySelector('[data-panel="starter"]');
    var starterBundleVariantId = starterPanel ? starterPanel.dataset.bundleVariantId : null;
    var starterBundlePrice = starterPanel ? starterPanel.dataset.bundlePrice : null;
    var starterBundleAvailable = starterPanel ? starterPanel.dataset.bundleAvailable === '1' : false;
    var starterCurrentName = root.querySelector('[data-starter-current-name]');
    var starterCurrentPrice = root.querySelector('[data-starter-current-price]');

    /* ── Variant pills ───────────────────────────────── */
    var pills = root.querySelectorAll('[data-variant-pill]');
    var defaultVariantValue = variantInput ? variantInput.value : null;
    var selectedVariantId = defaultVariantValue;
    // Selected variant SINGLE price/compare (money strings). Seed from the selected pill or the 1-Pair card.
    var selectedVariantPrice = null;
    var selectedVariantCompare = '';

    if (pills.length) {
      var initialPill = root.querySelector('[data-variant-pill].is-selected') || pills[0];
      selectedVariantId = initialPill.dataset.variantId || selectedVariantId;
      selectedVariantPrice = initialPill.dataset.variantPrice || null;
      selectedVariantCompare = initialPill.dataset.variantCompare || '';
      if (initialPill.dataset.subVariantId) currentSubVariantId = initialPill.dataset.subVariantId;
      if (initialPill.dataset.subPrice) currentSubPrice = initialPill.dataset.subPrice;
      if (initialPill.dataset.subPlanId) currentSubPlanId = initialPill.dataset.subPlanId;
      if (initialPill.dataset.subPrices) currentSubPrices = parsePrices(initialPill.dataset.subPrices) || currentSubPrices;
    }
    if (!selectedVariantPrice) {
      var firstPack = root.querySelector('input[name="new-pre-glued-full-pdp-pack"][value="1"]');
      selectedVariantPrice = firstPack ? firstPack.dataset.price : (priceCurrent ? priceCurrent.textContent : '£0');
    }

    function currentMode() {
      var activeTab = root.querySelector('[data-tab].is-active');
      return activeTab ? activeTab.dataset.tab : 'full-lash';
    }
    function checkedPack() {
      return root.querySelector('input[name="new-pre-glued-full-pdp-pack"]:checked') ||
             root.querySelector('input[name="new-pre-glued-full-pdp-pack"]');
    }

    function updateKlarna(priceStr) {
      if (!klarnaAmount || !priceStr) return;
      var num = parseMoney(priceStr);
      if (!isNaN(num) && klarnaInstallments > 0) {
        klarnaAmount.textContent = formatMoney(num / klarnaInstallments, priceStr);
      }
    }

    /* Recompute the 1-Pair / 2-Pairs pack-card prices from the selected variant.
       2 Pairs = qty 2 of the selected variant, display-only 5% off (cart promo applies the real discount). */
    function updatePackCards() {
      var single = parseMoney(selectedVariantPrice);
      optionInputs.forEach(function (inp) {
        var qty = parseInt(inp.dataset.quantity || '1', 10);
        if (qty === 1) {
          inp.dataset.price = selectedVariantPrice;
          inp.dataset.compare = selectedVariantCompare || '';
        } else {
          var full = single * qty;
          var now = full * 0.95;
          inp.dataset.price = formatMoney(now, selectedVariantPrice);
          inp.dataset.compare = formatMoney(full, selectedVariantPrice);
        }
      });
    }

    function updateStarterRefs() {
      if (starterCurrentPrice) starterCurrentPrice.textContent = selectedVariantPrice;
      if (starterCurrentName) {
        var base = starterCurrentName.dataset.starterBaseName || starterCurrentName.textContent;
        var pill = selectedPill();
        var vt = pill && pill.dataset.variantTitle ? pill.dataset.variantTitle : '';
        starterCurrentName.textContent = vt ? (base + ' – ' + vt) : base;
      }
      if (subDesc) {
        var b = subDesc.dataset.subBaseName || subDesc.textContent;
        var p2 = selectedPill();
        var vt2 = p2 && p2.dataset.variantTitle ? p2.dataset.variantTitle : '';
        subDesc.textContent = vt2 ? (b + ' – ' + vt2) : b;
      }
    }

    function selectedPill() {
      return root.querySelector('[data-variant-pill].is-selected');
    }

    /* Full-lash mode: apply a pack-card selection (qty multiple of the selected variant). */
    function selectOption(input) {
      if (!input) return;
      var label = input.closest('.new-pre-glued-full-pdp-option');
      root.querySelectorAll('.new-pre-glued-full-pdp-option').forEach(function (l) { l.classList.remove('is-selected'); });
      if (label) label.classList.add('is-selected');

      if (variantInput) variantInput.value = selectedVariantId;
      if (quantityInput) quantityInput.value = input.dataset.quantity || '1';
      if (sellingPlanInput) sellingPlanInput.value = '';

      if (priceCurrent && input.dataset.price) priceCurrent.textContent = input.dataset.price;
      if (atcPrice && input.dataset.price) atcPrice.textContent = input.dataset.price;

      if (priceCompare) {
        if (input.dataset.compare) {
          priceCompare.textContent = input.dataset.compare;
          priceCompare.removeAttribute('hidden');
        } else {
          priceCompare.setAttribute('hidden', '');
        }
      }
      if (atcCompare) {
        if (input.dataset.compare) { atcCompare.textContent = input.dataset.compare; atcCompare.removeAttribute('hidden'); }
        else { atcCompare.setAttribute('hidden', ''); }
      }
      updateKlarna(input.dataset.price);
    }

    function restoreLashMode() {
      var checked = checkedPack();
      if (checked) selectOption(checked);
    }

    /* Show/hide the Subscribe & Save tab for the selected length. If the active tab is
       subscribe and the length has no subscription, fall back to Full Lash so the form
       never submits a stale subscription variant/plan. */
    function setSubscribeAvailable(on) {
      if (!subscribeTab) return;
      subscribeTab.hidden = !on;
      subscribeTab.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (!on && subscribeTab.classList.contains('is-active')) {
        var fullTab = root.querySelector('[data-tab="full-lash"]');
        if (fullTab) fullTab.click();
      }
    }

    function applySubscribeMode(active) {
      if (!sellingPlanInput) return;
      if (active) {
        // No subscription resolved for this length — never add a stale subscription target.
        if (!currentSubVariantId) { restoreLashMode(); return; }
        // Plan ids are shared across all lengths (same Appstle selling-plan group), so the
        // select value stays valid when the length changes; only the per-plan price swaps.
        var planId = (sellingPlanSelect && sellingPlanSelect.value) || currentSubPlanId || defaultPlanId || '';
        // If the chosen plan isn't valid for this length, fall back to this length's default
        // so we never submit a selling_plan the variant doesn't offer.
        if (currentSubPrices && planId && !currentSubPrices[planId]) {
          planId = currentSubPlanId || defaultPlanId || planId;
          if (sellingPlanSelect && planId) sellingPlanSelect.value = planId;
        }
        sellingPlanInput.value = planId;
        // Native model: the lash variant itself on the chosen plan. Fallback model: the
        // dedicated subscription variant. Either way currentSubVariantId holds the target.
        if (variantInput) variantInput.value = currentSubVariantId || defaultVariantValue || '';
        if (quantityInput) quantityInput.value = '1';
        var subPriceStr = subPriceForPlan(planId) || currentSubPrice ||
          formatMoney(parseMoney(selectedVariantPrice) * (1 - subPct / 100), selectedVariantPrice);
        if (priceCurrent) priceCurrent.textContent = subPriceStr;
        if (priceCompare) priceCompare.setAttribute('hidden', '');
        if (atcPrice) atcPrice.textContent = subPriceStr;
        if (atcCompare) atcCompare.setAttribute('hidden', '');
        updateKlarna(subPriceStr);
      } else {
        sellingPlanInput.value = '';
        restoreLashMode();
      }
    }

    function applyStarterMode(active) {
      if (!variantInput) return;
      if (active && starterBundleVariantId) {
        variantInput.value = starterBundleVariantId;
        if (quantityInput) quantityInput.value = '1';
        if (sellingPlanInput) sellingPlanInput.value = '';
        if (starterBundlePrice) {
          if (priceCurrent) priceCurrent.textContent = starterBundlePrice;
          if (atcPrice) atcPrice.textContent = starterBundlePrice;
          updateKlarna(starterBundlePrice);
        }
        if (priceCompare) priceCompare.setAttribute('hidden', '');
        if (atcCompare) atcCompare.setAttribute('hidden', '');
      } else if (!active) {
        restoreLashMode();
      }
    }

    /* Choosing a variant pill drives everything for the current mode. */
    function selectVariant(pill) {
      if (!pill) return;
      selectedVariantId = pill.dataset.variantId || selectedVariantId;
      selectedVariantPrice = pill.dataset.variantPrice || selectedVariantPrice;
      selectedVariantCompare = pill.dataset.variantCompare || '';

      pills.forEach(function (p) {
        var on = p === pill;
        p.classList.toggle('is-selected', on);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      // Switch the gallery main image to this variant's assigned image, if any (reuses thumb -> show()).
      var vMediaId = pill.dataset.variantMediaId;
      if (vMediaId) {
        var vThumb = root.querySelector('[data-thumb-index][data-media-id="' + vMediaId + '"]');
        if (vThumb) vThumb.click();
      }

      // Per-variant starter-kit bundle (resolved server-side per pill).
      if (starterPanel) {
        if (pill.dataset.skVariantId) {
          starterBundleVariantId = pill.dataset.skVariantId;
          starterPanel.dataset.bundleVariantId = pill.dataset.skVariantId;
        }
        if (pill.dataset.skPrice) {
          starterBundlePrice = pill.dataset.skPrice;
          starterPanel.dataset.bundlePrice = pill.dataset.skPrice;
        }
        if (typeof pill.dataset.skAvailable !== 'undefined') {
          starterBundleAvailable = pill.dataset.skAvailable === '1';
        }
      }

      // Per-variant Subscribe & Save target (resolved server-side per pill).
      if (subPanel) {
        if (pill.dataset.subVariantId) {
          currentSubVariantId = pill.dataset.subVariantId;
          subPanel.dataset.subVariantId = pill.dataset.subVariantId;
          if (pill.dataset.subPrice) {
            currentSubPrice = pill.dataset.subPrice;
            subPanel.dataset.subPrice = pill.dataset.subPrice;
          }
          currentSubPrices = parsePrices(pill.dataset.subPrices) || null;
          if (pill.dataset.subPlanId) currentSubPlanId = pill.dataset.subPlanId;
          setSubscribeAvailable(true);
        } else {
          // This length has no resolved subscription — clear stale state and hide Subscribe.
          currentSubVariantId = null;
          currentSubPrice = null;
          currentSubPrices = null;
          setSubscribeAvailable(false);
        }
      }

      updatePackCards();
      updateStarterRefs();

      var mode = currentMode();
      if (mode === 'subscribe') applySubscribeMode(true);
      else if (mode === 'starter') applyStarterMode(true);
      else restoreLashMode();
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () { selectVariant(pill); });
    });

    // On load, open the gallery on the pre-selected variant's image (e.g. deep-linked ?variant=).
    (function () {
      var ip = root.querySelector('[data-variant-pill].is-selected');
      if (ip && ip.dataset.variantMediaId) {
        var it = root.querySelector('[data-thumb-index][data-media-id="' + ip.dataset.variantMediaId + '"]');
        if (it) it.click();
      }
    })();

    /* ── Tabs ────────────────────────────────────────── */
    var tabs = root.querySelectorAll('[data-tab]');
    var panels = root.querySelectorAll('[data-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.dataset.tab;
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.dataset.panel === id;
          p.classList.toggle('is-active', on);
          if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
        });
        applySubscribeMode(id === 'subscribe');
        applyStarterMode(id === 'starter');
      });
    });

    if (sellingPlanSelect) {
      sellingPlanSelect.addEventListener('change', function () {
        // In subscribe mode, switching frequency re-applies the plan id AND reprices.
        if (currentMode() === 'subscribe') applySubscribeMode(true);
        else if (sellingPlanInput && sellingPlanInput.value) sellingPlanInput.value = sellingPlanSelect.value;
      });
    }

    /* ── Options (1 Pair / 2 Pairs) ─────────────────── */
    optionInputs.forEach(function (i) { i.addEventListener('change', function () { selectOption(i); }); });

    /* ── Click-anywhere on option label selects radio ── */
    root.querySelectorAll('.new-pre-glued-full-pdp-option').forEach(function (lbl) {
      lbl.addEventListener('click', function () {
        var inp = lbl.querySelector('input[type="radio"]');
        if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });

    /* ── Initial sync ────────────────────────────────── */
    updatePackCards();
    updateStarterRefs();
    restoreLashMode();
  }

  /* ── Remove the Wishlist Hero heart on this PDP ─────────────────────
     The app INJECTS its heart(s) via JS after load (floating button + an
     in-form button), so CSS display:none doesn't stick — it keeps coming
     back. We delete the nodes and re-delete on any re-injection. */
  /* Only Wishlist-Hero-namespaced selectors — app-specific, won't match unrelated UI. */
  var WLH_SEL = '.wishlisthero-floating, [class*="wishlisthero"], [class*="wishlist-hero"], [class*="wlh-"], [id*="wishlisthero"]';
  function killWishlist() {
    try { document.querySelectorAll(WLH_SEL).forEach(function (el) { el.remove(); }); } catch (e) {}
  }
  function watchWishlist() {
    killWishlist();
    var t;
    var obs = new MutationObserver(function (mutations) {
      /* Only act when a wishlist node was actually added — avoids needless scans. */
      var hit = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 &&
            ((n.matches && n.matches(WLH_SEL)) || (n.querySelector && n.querySelector(WLH_SEL)));
        });
      });
      if (!hit) return;
      clearTimeout(t);
      t = setTimeout(killWishlist, 50);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    /* extra sweeps in case the app injects late */
    [300, 800, 1500, 3000].forEach(function (ms) { setTimeout(killWishlist, ms); });
  }

  function boot() {
    document.querySelectorAll('.new-pre-glued-full-pdp').forEach(init);
    watchWishlist();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
